<div class="logout">
    <message icon="fa-check-circle"
             message="Sie haben sich erfolgreich ausgeloggt."
             [showLinkToStart]="true"
    ></message>
</div>
